/**
 * Converts `number` or `string` value to `styled` `width` property.
 *
 * If the value is number, and it is more than 1, it is converted to px like `64` => `64px`.
 *
 * If the value is between (0, 1], it's converted to percent. Otherwise, it is directly set on the CSS property.
 *
 * ```
 * <Box sx={{ width: 1/4 }}> // Equivalent to width: '25%'
 * <Box sx={{ width: 300 }}> // Numbers are converted to pixel values.
 * <Box sx={{ width: '75%' }}> // String values are used as raw CSS.
 * <Box sx={{ width: 1 }}> // 100%
 * ```
 *
 * https://mui.com/system/sizing/
 *
 * @param value
 * @returns
 */
export function transformWidth(value) {
    if (typeof value === 'number') {
        // return value <= 1 && value !== 0 ? `${value * 100}%` : value;
        return value <= 1 && value !== 0 ? `${value * 100}%` : `${value}px`;
    }
    if (typeof value === 'string') {
        return value;
    }
    throw new Error('Unknown type of value: ', value);
}
